import Route from '@ember/routing/route';
import { service } from '@ember/service';
import DataModel from '../models/data';
import CircuitDataModel from '../models/circuitData';
import ENV from '../config/environment';
import { isTesting } from '@embroider/macros';
const LOCALES = { 'en-us': 'en', 'zh-cn': 'cn', 'ja-jp': 'jp', 'ru-ru': 'ru' };
const LOCALES_REVERSE = { en: 'en-us', cn: 'zh-cn', jp: 'ja-jp', ru: 'ru-ru' };

export default class IndexRoute extends Route {
  @service('aditools-analytics') analytics;
  @service site;
  @service cdp;
  @service intl;

  beforeModel() {
    // Ensure the presence of the terminal slash in the URL.
    let url = window.location.href.split(/[?#]/)[0];
    if (url[url.length - 1] !== '/') {
      let newUrl =
        url +
        '/' +
        (window.location.search.length > 0 ? window.location.search : '') +
        (window.location.hash.length > 0 ? window.location.hash : '');
      window.history.replaceState({}, '', newUrl);
    }
  }

  model(params) {
    const configURL = ENV.rootURL.endsWith('/') ? ENV.rootURL + 'siteconfig.json' : ENV.rootURL + '/siteconfig.json';
    let htmlElement = document?.querySelector('html');
    let fullLanguage = htmlElement?.getAttribute('lang');
    if (!fullLanguage) fullLanguage = 'en-us';
    const defaultLanguage = params.lang ? params.lang : LOCALES[fullLanguage];
    return this.site.start(configURL, ENV.rootURL, defaultLanguage, this.intl.locales).then((/*site*/) => {
      let precisionStudioMenuLinks = {
        PrecisionStudioUrl: this.site.PrecisionStudioUrl,
        FilterWizardUrl: this.site.FilterWizardUrl,
        AdcDriverUrl: this.site.AdcDriverUrl,
        PhotodiodeUrl: this.site.PhotodiodeUrl,
        DiamondUrl: this.site.DiamondUrl,
        SimDDSUrl: this.site.SimDDSUrl,
        SignalChainDesignerUrl: this.site.SignalChainDesignerUrl,
        VirtualEvalUrl: this.site.VirtualEvalUrl,
        DACErrorCalculatorUrl: this.site.DACErrorCalculatorUrl,
      };
      if (defaultLanguage === 'ru') {
        this.intl.setLocale(LOCALES_REVERSE['en']);
      } else {
        this.intl.setLocale(LOCALES_REVERSE[defaultLanguage]);
      }
      return this.cdp.getToolData().then((toolData) => {
        //Load analytics
        this.analytics.start(
          toolData.toolName,
          this.site.AnalyticsUrl,
          false /*isSSR*/,
          isTesting(),
          ENV.environment === 'development',
          null,
        );
        const model = DataModel.create({
          toolConfigData: toolData,
          precisionStudioLinks: precisionStudioMenuLinks,
          globalPartId: this.site.PartId,
          circuitModel: CircuitDataModel.create({}),
          adiBaseURL: this.site.SiteUrl + '/' + this.site.AdiLocale,
          adiLocale: this.site.AdiLocale,
          intl: this.intl,
        });
        return model.load();
      });
    });
  }
}
